<template>	
<Spinner v-if="isLoading" />
<Toast />	
<ConfirmDialog></ConfirmDialog>
<!-- <p class="test">ID: {{ id }}</p> -->
<form> 
	<div class="grid nested-grid">
		<div class="col-12">

			<div class="card fluid cardheader">
				<div class="col-12 clsESHeaderGroup">
					<!-- <div v-if="isMinisterstvo" class="vsepolnilnice">
					    <router-link :to="{ name: 'EnergySites', params: { viewcompanyid: viewcompanyid, viewedCompanName: viewedCompanName }}"> 
                            <Button icon="pi pi-th-large" class="p-button-raised p-button-rounded p-button-success buttonpolnilnice" />
                        </router-link>	
					</div>						 -->
					<div v-if="!isMinisterstvo" class="clsESHeader">
						<h5 class="stationsHeader">{{ tmpTitleStation }}</h5><h5 v-if="id !='00000000-0000-0000-0000-000000000000'">: {{ energysite.Name }}</h5>	
					</div>
					<div v-if="isMinisterstvo && !(viewedCompanName === 'undefined')" class="adminheadernamegroup">
						<h6 class="stationsHeaderAdmin">{{ translated('company') + ': ' + viewedCompanName }}</h6>
						<h5 class="stationsHeaderAdminCName">{{ tmpTitleStation }}</h5><h5 v-if="id !='00000000-0000-0000-0000-000000000000'">: {{ energysite.Name }}</h5>
					</div>	
					<div v-if="!isMinisterstvo" class="headerdelete">
						<Button :disabled="!editenabled" :label="translated('removeenergysite')" class="p-button-raised p-button-danger removeenergysite" icon="pi pi-trash" @click="removeEnergySite" />
						<Button v-if="editenabled" icon="pi pi-lock-open" class="p-button-rounded p-button-danger lockremovesite" @click="editenabled=false" />
						<Button v-if="!editenabled" icon="pi pi-lock" class="p-button-rounded p-button-danger lockremovesite" @click="editenabled=true" />												
					</div>							
				</div>		
			</div>		

			

			<div class="card fluid">       
				<div class="field grid">
					<div class="col-6">

						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('poolownerthirdperson') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.thirdpartyowner" :binary="true" />
							</div>                        
						</div>
						
						<div>
							<div class="field grid" v-if="energysite.thirdpartyowner">
								<label class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.Name.$invalid && submitted}">{{ translated('poolownertypelabel') }}</label>
								<div class="col-12 md:col-7">								
									<Dropdown :disabled="!energysite.thirdpartyowner || isMinisterstvo" v-model="energysite.PoolOwnerType" :options="OwnerTypeAllOptions" optionLabel="label" optionValue="value" 
									:placeholder="translated('selectowner')" @change="spremembaTipLastnikaLokacije" />	
								</div> 											
							</div>

							<div class="field grid" v-if="energysite.thirdpartyowner && energysite.PoolOwnerType == 'pravnaoseba'" >
								<label for="street" class="col-12 md:col-5 mb-md-0">{{ translated('poolownercompanylabel') }}</label>
								<div class="col-12 md:col-7">
									<InputText :disabled="!energysite.thirdpartyowner || isMinisterstvo || energysite.PoolOwnerType != 'pravnaoseba'" type="text" v-model="energysite.PoolOwnerName" />
								</div>                        
							</div>

							<div class="field grid davcnamaticnapoolowner" v-if="energysite.thirdpartyowner && energysite.PoolOwnerType == 'pravnaoseba'">

								<label class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.Name.$invalid && submitted}">{{ translated('poolownertaxregid') }}</label>
								<div class="col-6 md:col-4">
									<span class="p-float-label">
										<InputText type="text" v-model="energysite.PoolOwnerRegisterId" :disabled="!energysite.thirdpartyowner || isMinisterstvo || energysite.PoolOwnerType != 'pravnaoseba'" />
										<label>{{ translated('ownrregisterid') }}</label>
									</span>																
								</div>  								
								<div class="col-6 md:col-3">
									<span class="p-float-label">
										<InputText type="text" v-model="energysite.PoolOwnerTaxId" :disabled="!energysite.thirdpartyowner || isMinisterstvo || energysite.PoolOwnerType != 'pravnaoseba'" />
										<label>{{ translated('ownertaxid') }}</label>
									</span>																
								</div>  											
							</div>							
						</div>

						<div class="field grid">
							<label for="name" class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.Name.$invalid && submitted}">{{ translated('companyname') }} *</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="name" type="text" v-model="energysite.Name" :class="{'p-invalid':v$.energysite.Name.$invalid && submitted}" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="street" class="col-12 md:col-5 mb-md-0">{{ translated('street') }}</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="street" type="text" v-model="energysite.Street" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="street1" class="col-12 md:col-5 mb-md-0"></label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="street1" type="text" v-model="energysite.Street1" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="housenumber" class="col-12 md:col-5 mb-md-0">{{ translated('housenumber') }}</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="housenumber" type="text" v-model="energysite.HouseNumber" />
							</div>                        
						</div>			

						<div class="field grid">
							<label for="zip" class="col-12 md:col-5 mb-md-0" :class="{'p-error': (v$.energysite.Zip.$invalid ||v$.energysite.City.$invalid) && submitted}">{{ translated('zipcity') }} *</label>
							<div class="col-3 md:col-2">
								<InputText :disabled="isMinisterstvo" id="zip" type="text" v-model="energysite.Zip" :class="{'p-invalid':v$.energysite.Zip.$invalid && submitted}" />
							</div>  
							<div class="col-9 md:col-5">
								<InputText :disabled="isMinisterstvo" id="city" type="text" v-model="energysite.City" :class="{'p-invalid':v$.energysite.City.$invalid && submitted}" />
							</div>  			                      
						</div>		
						<div class="field grid">
							<label for="country" class="col-12 md:col-5 mb-md-0">{{ translated('country') }}</label>
							<div class="col-12 md:col-7">
								<InputText id="country" type="text" v-model="energysite.Country" disabled />
							</div>                        
						</div>
						<div class="field grid">
							<label for="locationtype" class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.LocationType.$invalid && submitted}">{{ translated('locationtype') }} *</label>
							<div class="col-12 md:col-7">
								<Dropdown :disabled="isMinisterstvo" v-model="energysite.LocationType" :options="LocationTypeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectloctype')" :class="{'p-invalid':v$.energysite.LocationType.$invalid && submitted}" />	
							</div>                        
						</div>		
						<div class="field grid ownersection">
							<label class="col-12 md:col-5 mb-md-0">{{ translated('locowner') }}</label>
							<div class="col-12 md:col-3">								
								<Dropdown :disabled="isMinisterstvo" v-model="energysite.OwnerType" :options="OwnerTypeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectowner')" @change="spremembaTipLastnikaLokacije" />	
							</div>  

							<div class="col-12 md:col-2">
								<span class="p-float-label">
									<InputText id="maticnast" type="text" v-model="energysite.OwnerTaxId" :disabled="energysite.OwnerType!='pravnaoseba' || isMinisterstvo" />
									<label>{{ translated('ownertaxid') }}</label>
								</span>																
							</div>  
							<div class="col-12 md:col-2">
								<span class="p-float-label">
									<InputText id="davcnast" type="text" v-model="energysite.OwnerRegisterId" :disabled="energysite.OwnerType!='pravnaoseba' || isMinisterstvo" />
									<label>{{ translated('ownrregisterid') }}</label>
								</span>																
							</div>  														                      
						</div>						
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('evseid') }}</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" type="text" v-model="energysite.EvseId" />
							</div>                        
						</div>	

						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('paymenttypes') }}</label>
							<div class="col-12 md:col-7">
								<MultiSelect :disabled="isMinisterstvo" v-model="energysite.PaymentTypes" :options="PaymentTypesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectpaymenttype')" />	
							</div>                        
						</div>							
						
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('contractproviders') }}</label>
							<div class="col-12 md:col-7">
								<!-- <InputText :disabled="isMinisterstvo" type="text" v-model="energysite.ContractProviders" /> -->
								<Textarea :disabled="isMinisterstvo" class="textareCProviders" v-model="energysite.ContractProviders" autoResize="false" rows="5" maxlength="500" />
							</div>                        
						</div>	

						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('isoperational') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.IsOperational" :binary="true" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('ispublic') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.IsPublic" :binary="true" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('permanentlyclosed') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.PermanentlyClosed" :binary="true" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('temporaryclosed') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.TemporaryClosed" :binary="true" />
							</div>                        
						</div>

						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('accfor') }}</label>
							<div class="col-12 md:col-7">
								<MultiSelect :disabled="isMinisterstvo" v-model="energysite.AccessibleFor" :options="VehicleTypesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectaccfor')" />	
							</div>                        
						</div>		
						
						

						<div class="field grid">
							<label for="maxvehicleweight" class="col-12 md:col-5 mb-md-0">{{ translated('maxvehicleweight') }}</label>
							<div class="col-12 md:col-7">
								<InputNumber :disabled="isMinisterstvo" id="maxvehicleweight" v-model="energysite.MaxVehicleWeight"  />
							</div>                        
						</div>

						<div class="field grid">
							<label for="maxvehicleheight" class="col-12 md:col-5 mb-md-0">{{ translated('maxvehicleheight') }}</label>
							<div class="col-12 md:col-7">
								<InputNumber :disabled="isMinisterstvo" id="maxvehicleheight" v-model="energysite.MaxVehicleHeight" />
							</div>                        
						</div>
						
						<div class="field grid">
							<label for="maxvehiclelength" class="col-12 md:col-5 mb-md-0">{{ translated('maxvehiclelength') }}</label>
							<div class="col-12 md:col-7">
								<InputNumber :disabled="isMinisterstvo" id="maxvehiclelength" v-model="energysite.MaxVehicleLength" />
							</div>                        
						</div>
						
						<div class="field grid">
							<label for="maxvehiclewidth" class="col-12 md:col-5 mb-md-0">{{ translated('maxvehiclewidth') }}</label>
							<div class="col-12 md:col-7">
								<InputNumber :disabled="isMinisterstvo" id="maxvehiclewidth" v-model="energysite.MaxVehicleWidth" />
							</div>                        
						</div>						




						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('parkinginftype') }}</label>
							<div class="col-12 md:col-7">
								<Dropdown :disabled="isMinisterstvo" v-model="energysite.AssociatedInfrastructure.Type" :options="AssociatedInfrastructureTypeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectowner')" @change="spremembaTipLastnikaLokacije" />	
							</div>                        
						</div>
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('carparkingcap') }}</label>
							<div class="col-12 md:col-7">
								<InputNumber :disabled="isMinisterstvo" id="lat" v-model="energysite.AssociatedInfrastructure.CarParkingCapacity" :class="{'p-invalid':v$.energysite.AssociatedInfrastructure.CarParkingCapacity.$invalid && submitted}" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('truckparkcap') }}</label>
							<div class="col-12 md:col-7">
								<InputNumber :disabled="isMinisterstvo" id="lat" v-model="energysite.AssociatedInfrastructure.TruckParkingCapacity" :class="{'p-invalid':v$.energysite.AssociatedInfrastructure.TruckParkingCapacity.$invalid && submitted}" />
							</div>                        
						</div>
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('bikeparkcap') }}</label>
							<div class="col-12 md:col-7">
								<InputNumber :disabled="isMinisterstvo" id="lat" v-model="energysite.AssociatedInfrastructure.BikeParkingCapacity" :class="{'p-invalid':v$.energysite.AssociatedInfrastructure.BikeParkingCapacity.$invalid && submitted}" />
							</div>                        
						</div>			
						
						<div class="hydrogenSection" v-if="hydrogenExists">
							<div class="field grid">
								<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('hydrogencomulativedaycapacity') }}</label>
								<div class="col-12 md:col-7">
									<InputNumber :disabled="isMinisterstvo" id="lat" v-model="energysite.HydrogenCumulativeCapacityPerDay" />
								</div>                        
							</div>			
							
							<div class="field grid">
								<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('hydrogenbelowminimum') }}</label>
								<div class="col-12 md:col-7">									
									<Checkbox :disabled="isMinisterstvo" v-model="energysite.HydrogenBelowMinimum" :binary="true" />
								</div>                        
							</div>								
						</div>

						<div class="electricSection" v-if="electricExists">
							<div class="field grid">
								<label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('maxpowersite') }}</label>
								<div class="col-12 md:col-7">
									<InputNumber :disabled="isMinisterstvo" v-model="electricMaxPower" :minFractionDigits="2" locale="sl-SI" />
								</div>                        
							</div>	
						</div>


						<div class="field grid">
							<!-- sortField="DayIndex" :sortOrder="1" -->									
							<div class="col-12">
								<DataTable :value="energysite.WorkingHours" sortMode="multiple" :multiSortMeta="multiSortWorkingHours" responsiveLayout="scroll">
									<template #header>
										<div class="flex justify-content-between p-ai-center">
											<h5 class="m-0">{{ translated('workinghours') }}</h5>
											<Button v-if="!isMinisterstvo" icon="pi pi-plus" class="p-button-rounded p-button-secondary" @click="openModalAddWorkingHour" />
										</div>
									</template>									
									<Column field="DayInWeek" :header="translated('daytable')"></Column>
									<Column :header="translated('fromtable')">
										<template #body="slotProps">
											{{ formatTime(slotProps.data.OpenFromHour,slotProps.data.OpenFromMinute) }}
										</template>									
									</Column>
									<Column :header="translated('tilltable')">
										<template #body="slotProps">
											{{ formatTime(slotProps.data.OpenTillHour,slotProps.data.OpenTillMinute) }}
										</template>										
									</Column>
									<Column :exportable="false">
										<template #body="slotProps">
											<Button v-if="!isMinisterstvo" icon="pi pi-trash" class="p-button-rounded p-button-warning deletebutton" @click="deleteWorkingHour(slotProps.data)" />
											<Button v-if="!isMinisterstvo" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2 editbutton" @click="openModalEditWorkingHour(slotProps.data)" />											
										</template>
									</Column>								
								</DataTable>
							</div>                        
						</div>	

						<div class="fueldatasection">
							<FuelData :FuelSpecificData="FuelStecyficDataSorted" :key="energysite.Id" @removeFuelData="removeFuelData" />
						</div>

						
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-4 mb-md-0">{{ translated('externalsystemid') }}</label>
							<div class="col-12 md:col-8">
								<InputText class="editenabledExternalID" type="text" v-model="energysite.ExternalSystemId" :disabled="!editenabledExternalId || isMinisterstvo" />
								<Button v-if="editenabledExternalId && !isMinisterstvo" icon="pi pi-lock-open" class="p-button-rounded p-button-warning btneditenabledExternalId" @click="editenabledExternalId=false" />
                				<Button v-if="!editenabledExternalId && !isMinisterstvo" icon="pi pi-lock" class="p-button-rounded p-button-warning btneditenabledExternalId" @click="editenabledExternalId=true" />

							</div>                        
						</div>	

					</div>

					<div class="col-6 rightColData">						
						<div class="field grid">
							<label for="responsibleperson" class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.ResponsiblePerson.$invalid && submitted}">{{ translated('responsibleperson') }} *</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="responsibleperson" type="text" v-model="energysite.ResponsiblePerson" :class="{'p-invalid':v$.energysite.ResponsiblePerson.$invalid && submitted}" />
							</div>                        
						</div>		
						<div class="field grid">
							<label for="contactperson" class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.ContactPerson.$invalid && submitted}">{{ translated('contactperson') }} *</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="contactperson" type="text" v-model="energysite.ContactPerson" :class="{'p-invalid':v$.energysite.ContactPerson.$invalid && submitted}" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="contactphone" class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.ContactPhone.$invalid && submitted}">{{ translated('contactphone') }} *</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="contactphone" type="text" v-model="energysite.ContactPhone" :class="{'p-invalid':v$.energysite.ContactPhone.$invalid && submitted}" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="contactemail" class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.energysite.ContactEmail.$invalid && submitted}">{{ translated('contactemail') }} *</label>
							<div class="col-12 md:col-7">
								<InputText :disabled="isMinisterstvo" id="contactemail" type="text" v-model="energysite.ContactEmail" :class="{'p-invalid':v$.energysite.ContactEmail.$invalid && submitted}" />
							</div>                        
						</div>		

						
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('ispersononsite') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.IsPersonOnSite" :binary="true" />
							</div>                        
						</div>						


						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('isroofed') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.IsRoofed" :binary="true" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('isilluminated') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.IsIlluminated" :binary="true" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('hascateringservice') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.HasCateringService" :binary="true" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('hasbathrooms') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.HasBathrooms" :binary="true" />
							</div>                        
						</div>	
						<div class="field grid">
							<label for="evseid" class="col-12 md:col-11 mb-md-0">{{ translated('hasRestingFacilities') }}</label>
							<div class="col-12 md:col-1">
								<Checkbox :disabled="isMinisterstvo" v-model="energysite.HasRestingFacilities" :binary="true" />
							</div>                        
						</div>	 
						<div class="field grid">
							<label for="notes" class="col-12">{{ translated('otherfacilities') }}</label>
							<div class="col-12">
								<Textarea :disabled="isMinisterstvo" class="statiotherfacilities" v-model="energysite.OtherFacilities" :autoResize="false" rows="3" maxlength="500" />
							</div>                        
						</div>	


						<Divider type="dashed"/>

						<div class="field grid">
							<label for="notes" class="col-12">{{ translated('notes') }}</label>
							<div class="col-12">
								<Textarea :disabled="isMinisterstvo" class="stationnotes" v-model="energysite.Notes" :autoResize="false" rows="6" />
							</div>                        
						</div>	

						<div class="field grid latlongplaceholder">							
							<div class="col-6">
								<span class="p-float-label">
									<InputNumber :disabled="isMinisterstvo" id="lat" v-model="energysite.Lat" mode="decimal" :minFractionDigits="6" locale="sl-SI" :class="{'p-invalid':v$.energysite.Lat.$invalid && submitted}" />
									<label :class="{'p-error': v$.energysite.Lat.$invalid && submitted}">{{ translated('latitude') }} *</label>
								</span>
							</div>   
							<div class="col-6">
								<span class="p-float-label">
									<InputNumber :disabled="isMinisterstvo" id="long" v-model="energysite.Long" mode="decimal" :minFractionDigits="6" locale="sl-SI" :class="{'p-invalid':v$.energysite.Long.$invalid && submitted}" />
									<label :class="{'p-error': v$.energysite.Long.$invalid && submitted}">{{ translated('longitude') }} *</label>
								</span>
							</div> 
							<div class="col-12 placeholderformap">   	
								<div id="rm2Map" style="height: 100%; width: 100%" :style-url="`${publicPath}vector.prometej.mb-style.json`"></div>   	
								<!-- <div id="rm2Map" style="height: 100%; width: 100%" style-url="https://gis-dars.geoprostor.net/vt/styles/vector.prometej.mb-style.json"></div>	-->
							</div>																					                     
						</div>	

					</div>		
				</div>			
			</div>
			
		</div>


		<!-- STATIONS -->
		<div class="col-12">
			<div class="card fluid cardheader">
				<div class="col-12 stationsHeader">
					<h5>{{ translated('stationstitle') }}</h5>
				</div>	
				<div class="stationHeaderAdd">
					<Button v-if="!isMinisterstvo" icon="pi pi-plus" class="p-button-raised p-button-rounded p-button p-button-sm" @click="openModalAddStation" />
				</div>															
			</div>	
			
			<div class="card">  
				<div v-if="energysite.ChargeStations">
					<div v-for="stationx in energysite.ChargeStations" :key="stationx.CreatedDate" >
						<!-- <p>{{ stationx }}</p> -->
						<Station :Station="stationx" :FinancedAllOptions="FinancedAllOptions" :ReceivingSupportCompaniesAllOptions="ReceivingSupportCompaniesAllOptions" :FinancedCompanieRecords="FinancedCompanieRecords" :ReceivingAgreementsAllOptions="ReceivingAgreementsAllOptions" :PaymentTypesAllOptions="PaymentTypesAllOptions" :submitted="submitted"  :key="stationx.CreatedDate" @removeStation="removeElementEvent" /> 
					</div>
				</div>
			</div>	
		</div>

		<div v-if="!isMinisterstvo" class="col-12">
			<div class="card fluid saveCard">
				<div class="col-12 servererrormessage" v-if="serverSubmitError.length>0 && isLoading==false">
					<span>{{ serverSubmitError }}</span>
				</div>					
				<div class="col-12 saveCardRow">
					<Button :label="translated('saveenergysitebutton')" @click="handleSubmit(!v$.$invalid)"/>
				</div>	
																	
			</div>				
		</div>

 		

	</div>
</form>

	
<Dialog v-model:visible="displayModalAddStation" :style="{width: '30vw'}" :modal="true" :header="translated('addstationbtit')" class="globalDialog">
		<div class="card fluid">       

			<div class="field grid">
				<label for="name1" class="col-12 md:col-4 mb-md-0">{{ translated('companyname') }}</label>
				<div class="col-12 md:col-8">
					<InputText id="name1" type="text" v-model="tmpStationName" />							
				</div>                        
			</div>		
			<div class="field grid">
				<label for="newevseid" class="col-12 md:col-4 mb-md-0">{{ translated('evseid') }}</label>
				<div class="col-12 md:col-8">
					<InputText id="newevseid" type="text" v-model="tmpStationEvseid" />							
				</div>  						
			</div>	
			<div class="field grid">
				<label for="newevseid" class="col-12 md:col-4 mb-md-0">{{ translated('authident') }}</label>
				<div class="col-12 md:col-8">
					<Dropdown v-model="tmpAuth" :options="AuthenticationAndIdentificationAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectauthtype')" />								
				</div>  						
			</div>	 					
			<div class="field grid">
				<label for="notestmp" class="col-12">{{ translated('notes') }}</label>
				<div class="col-12">
					<Textarea id="notestmp" v-model="tmpStationNotes" :autoResize="false" rows="6" />
				</div>                        
			</div>														
		</div>
	<template #footer>
		<Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalAddStation" class="p-button-text"/>
		<Button :label="translated('addbutton')" icon="pi pi-check" @click="closeAndAddModalAddStation" autofocus />				
	</template>
</Dialog>

<Dialog v-model:visible="displayModalAddWorkingHour" :style="{width: '30vw'}" :modal="true" class="globalDialog">
    <template #header>
		<!-- <h4>{{ workingHourPopupTitle }}</h4> -->
		<span class="p-dialog-title">{{ workingHourPopupTitle }}</span>
	</template>	
	<div class="card fluid">       

		<div class="field grid">
			<label for="name1" class="col-12 md:col-2 mb-md-0">{{ translated('daytable') }}</label>
			<div class="col-12 md:col-10">
				<Dropdown v-model="tmpDayInWeek" :options="DayInWeekAlloptions" optionLabel="label" optionValue="value" :placeholder="translated('selectdayweek')" :class="{'p-invalid':errDan}" />																	
			</div>                        
		</div>		
		<div class="field grid">
			<label class="col-12 md:col-2 mb-md-0">{{ translated('fromtable') }}</label>
			<div class="col-6 md:col-5">
				<Dropdown v-model="tmpOpenHour" :options="HoursAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selecthour')" :class="{'p-invalid':errOd}" />
			</div>  				
			<div class="col-6 md:col-5">
				<Dropdown v-model="tmpOpenMinute" :options="MinutesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectminute')" :class="{'p-invalid':errOdMin}"/>
			</div>  						
													
		</div>	
		<div class="field grid">
			<label class="col-12 md:col-2 mb-md-0">{{ translated('tilltable') }}</label>
			<div class="col-6 md:col-5">
				<Dropdown v-model="tmpCloseHour" :options="HoursAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selecthour')" :class="{'p-invalid':errDo}" />
			</div>  				
			<div class="col-6 md:col-5">
				<Dropdown v-model="tmpCloseMinute" :options="MinutesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectminute')" :class="{'p-invalid':errDoMin}"/>
			</div>  						
													
		</div>			
												
	</div>
	<template #footer>
		<Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalAddWorkingHour" class="p-button-text"/>
		<Button :label="translated('addbutton')" icon="pi pi-check" @click="closeAndAddModalAddWorkingHour" autofocus />
	</template>
</Dialog>


</template>

<script>
import { email, required, between, numeric, minLength, maxLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import Spinner from "@/components/Spinner.vue"
import createHttp from "@/services/http";
import Station from '@/components/Station.vue'
import FuelData from '@/components/FuelData.vue'
import { computed } from "vue"
import store from "@/store";


// const mustBeCool = (value) => !helpers.req(value) || value.indexOf('cool') >= 0

export default {
	/*
	provide() {
		return {
		$v: this.$v
		}
	},	
	*/
	setup: () => ({ v$: useVuelidate() }),
	components: { Station, FuelData, Spinner },
  	props: ['id','viewedCompanName', 'viewcompanyid'],
  	data() {
    	return {
			serverSubmitError: '',
			editenabledExternalId: false,
			editenabled: false,
			publicPath: process.env.BASE_URL,
			isLoading: false,
			mc: {},			
			translated: computed(() => store.getters.getTranslate),
			displayModalAddStation: false,		
			displayModalAddWorkingHour: false,	
			submitted: false,
			energysite: {
				Id: "",
				Name: "",
				Street: "",
				Street1: "",
				HouseNumber: "",
				City: "",
				Zip: "",
				Country: "Slovenija",
				Currency: "",
				EvseId: "",
				ContactEmail: "",
				ContactPhone: "",
				ContactPerson: "",
				IsPersonOnSite: false,
				IsRoofed: false,
				IsIlluminated: false,
				HasCateringService: false,
				HasBathrooms: false,
				HasRestingFacilities: false,
				OtherFacilities: "",
				ResponsiblePerson: "",
				IsOperational: false,
				IsPublic: false,
				TeporaryClosed: false,
				Lat: null,
				Long: null,
				Notes: "",
				AccessibleFor: [],
				ChargeStations: [],
				WorkingHours: [],
				FuelSpecificData: [],
				AssociatedInfrastructure: {
					Type: 'other',
					CarParkingCapacity: 0,
					TruckParkingCapacity: 0,
					BikeParkingCapacity: 0
				},
				PoolOwnerType: null,
				PoolOwnerName: null,
				PoolOwnerTaxId: null,
				PoolOwnerRegisterId: null,
				TntDistance: null,
				thirdpartyowner: false,			
				thirdpartiscompany: computed(() => this.energysite.PoolOwnerType == 'pravnaoseba' ? true : false)				
			},			
            AuthenticationAndIdentificationAllOptions: [
                {label: "activeRFIDChip", value: "activeRFIDChip"},
                {label: "apps", value: "apps"},
                {label: "calypso", value: "calypso"},
                {label: "mifareClassic", value: "mifareClassic"},
                {label: "mifareDesfire", value: "mifareDesfire"},
                {label: "noAccess", value: "noAccess"},
                {label: "overTheAir", value: "overTheAir"},
                {label: "phoneDialog", value: "phoneDialog"},
                {label: "phoneSMS", value: "phoneSMS"},
                {label: "pinpad", value: "pinpad"},
                {label: "PLC", value: "PLC"},
                {label: "prepaidCard", value: "prepaidCard"},
                {label: "unlimitedAccess", value: "unlimitedAccess"}                
            ],
			DayInWeekAlloptions: [
				{label: "Monday", value: "Monday"},
				{label: "Tuesday", value: "Tuesday"},
				{label: "Wednesday", value: "Wednesday"},
				{label: "Thursday", value: "Thursday"},
				{label: "Friday", value: "Friday"},
				{label: "Saturday", value: "Saturday"},
				{label: "Sunday", value: "Sunday"}
			],
			HoursAllOptions: [
				{label: "00", value: "00"},
				{label: "01", value: "01"},
				{label: "02", value: "02"},
				{label: "03", value: "03"},
				{label: "04", value: "04"},
				{label: "05", value: "05"},
				{label: "06", value: "06"},
				{label: "07", value: "07"},
				{label: "08", value: "08"},
				{label: "09", value: "09"},
				{label: "10", value: "10"},
				{label: "11", value: "11"},
				{label: "12", value: "12"},
				{label: "13", value: "13"},
				{label: "14", value: "14"},
				{label: "15", value: "15"},
				{label: "16", value: "16"},
				{label: "17", value: "17"},
				{label: "18", value: "18"},
				{label: "19", value: "19"},
				{label: "20", value: "20"},
				{label: "21", value: "21"},
				{label: "22", value: "22"},
				{label: "23", value: "23"},
			],
			MinutesAllOptions: [
				{label: "00", value: "00"},
				{label: "15", value: "15"},
				{label: "30", value: "30"},
				{label: "45", value: "45"}
			],
			LocationTypeAllOptions: [
                {label: "Počivališče", value: "pocivalisce"},
				{label: "Trgovski center", value: "trgovskicenter"},
				{label: "Bencinski servis", value: "bencinskiservis"},
				{label: "Stanovanjska soseska", value: "stanovanjskasoseska"},
				{label: "Parkirišče", value: "parkirisce"},
				{label: "Naselje", value: "naselje"},
				{label: "P+R", value: "PR"},
				{label: "Gostinjski objekt", value: "gostinskiobjekt"},
				{label: "Javni objekt", value: "javniobjekt"},
				{label: "Drugo", value: "drugo"}
            ],
			OwnerTypeAllOptions: [
				{label: "Pravna oseba", value: "pravnaoseba"},
				{label: "Fizična oseba", value: "fizicnaoseba"}
			],
			AssociatedInfrastructureTypeAllOptions: [				
				{label: "Parkirišče (carPark)", value: "carPark"},
				{label: "Rentacar postaja (carRentalStation)", value: "carRentalStation"},
				{label: "Parkirišče za tovornjake (lorryParkingSite)", value: "lorryParkingSite"},
				{label: "Letališče (airport)", value: "airport"},

				{label: "Parkirni prostor (parkingSite)", value: "parkingSite"},
				{label: "Parkirišče javnega prevoza (publicTransportDepot)", value: "publicTransportDepot"},
				{label: "Terensko parkirišče (field)", value: "field"},

				{label: "Ostalo (other)", value: "other"}
			],			
      		dropdownItem: null,
			tmpStationName: "",
			tmpStationEvseid: "",
			tmpStationNotes: "",
			tmpAuth: null,
			tmpWorkingHourId: null,
			tmpDayInWeek: null,
			tmpOpenHour: null,
			tmpOpenMinute: null,
			tmpCloseHour: null,
			tmpCloseMinute: null,
			errDan: false,
			errOd: false,
			errOdMin: false,
			errDo: false,
			errDoMin:false,
		//	tmpTitleAddWorkingHour: 'Add new working hour',
		//	tmpTitleEditWorkingHour: 'Edit working hour',
			workingHourPopupTitle: '',
			PaymentTypesAllOptions: [],
			VehicleTypesAllOptions: [],
			FinancedAllOptions: [],
			ReceivingSupportCompaniesAllOptions: [],
			FinancedCompanieRecords: [],
			ReceivingAgreementsAllOptions: [],
			tmpTitleStation: '',
			multiSortWorkingHours: [
				{field: 'DayIndex', order: 1},
				{field: 'OpenFromHour', order: 1}
			]

		};
	},
    validations() {
        let myvalidations = {
            energysite: {
				Name: { required },
				Zip: { required },
				City: { required },
				LocationType: { required },
				ResponsiblePerson: { required },
				ContactPerson: { required },
				ContactPhone: { required },
				ContactEmail: { required, email },
				Long: { required, between: between(13.5, 16.6) },
				Lat: { required, between: between(45.3, 46.9) },
				AssociatedInfrastructure: {
					CarParkingCapacity: { required, numeric },
					TruckParkingCapacity: { required, numeric },
					BikeParkingCapacity: { required, numeric }
				}
			}
        };

/*
				Long: { required, between: between(13.5, 16.6) },
				Lat: { required, between: between(45.3, 46.9) },


*/
    //    if(this.isMSP) { myvalidations.MSPCode = { required, mspcpoid }; }
    //    if(this.isCPO) { myvalidations.CPOCode = { required, mspcpoid }; }        

        return myvalidations;
    },	
    computed: {
		/*
        currentUserRole() {
            return this.$store.getters.getRole;
        },*/
		isMinisterstvo() {
			return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
            //return (this.$store.getters.getRole=="MAdmin" || this.$store.getters.getRole=="MUser");
			//return true;
        },
		hydrogenExists() {
			return this.energysite.ChargeStations.some(station =>
				station.RefillPoints && station.RefillPoints.some(refill => refill.Fuel === 'Hydrogen')
			);
		},
		electricExists() {
			return this.energysite.ChargeStations.some(station =>
				station.RefillPoints && station.RefillPoints.some(refill => refill.Fuel === 'Electric')
        	);
    	},
		electricMaxPower: {
			get() {
				return (this.energysite.ElectricMaxPower / 1000).toFixed(2);
			},
			set(value) {
				this.energysite.ElectricMaxPower = parseFloat(value) * 1000;
			}
		},
		FuelStecyficDataSorted() {
			return this.energysite.FuelSpecificData.sort((a, b) => {
				// Sort by Fuel first
				if (a.Fuel < b.Fuel) return -1;
				if (a.Fuel > b.Fuel) return 1;
				
				// If Fuel is the same, sort by OrganicGasType (handling null values)
				const aType = a.OrganicGasType || '';
				const bType = b.OrganicGasType || '';
				if (aType < bType) return -1;
				if (aType > bType) return 1;
				
				return 0;
			});
		}
    },       
  	async created() {

		this.$nextTick(async function () {

			this.mc = new rmap2.MapContainer("rm2Map");

			this.isLoading=true;
			if(!this.isMinisterstvo)
			{
				if(this.id !='00000000-0000-0000-0000-000000000000') {
					this.tmpTitleStation = this.translated('editingenergysite');
				} else {
					this.tmpTitleStation = this.translated('neweergysitetitle');
				}
			} else {
				this.tmpTitleStation = this.translated('energysite');
			}


			
						
			//console.log('MC');
			//console.log(this.mc);

			// 2021-08-19 Gorazd: Sedaj dovolim tudi preview Ministerstvu, prej nisem!
			/*
			if (this.$store.getters.getRole!='CAdmin') {
				if (this.$store.getters.getRole=='MAdmin') {
					this.$router.push({ name: 'Companies', params: { approved: 1 } });
					return;
				} else {
					this.$router.push('/');
					return;
				}				
			}
			*/

			const http = createHttp(true);
			const resultPT = await http.get(process.env.VUE_APP_API_FOLDER + "/GetPaymentTypes");
			/*
			console.log('payment types');
			console.log(resultPT);
			console.log('logiram vse payment type');
		*/
			resultPT.data.forEach(item => {
				const elPT = {label: item.Name, value: item.Id}
				this.PaymentTypesAllOptions.push(elPT)
			});

			//console.log(this.PaymentTypesAllOptions);

			// Naložim vse tipe vozil, ki lahko pristopajo
			const resultVT = await http.get(process.env.VUE_APP_API_FOLDER + "/GetVehicleTypes");

			

			/*
			console.log('GetVehicleTypes');
			console.log(resultVT);
			console.log('logiram vse Vehicle type');
		*/
			resultVT.data.forEach(item => {
				const elVT = {label: item.VehicleType, value: item.Id}
				this.VehicleTypesAllOptions.push(elVT)
			});



			const resultFinanced = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinanceRecords");
			resultFinanced.data.forEach(item => {
				const elFinanced = {label: item.Name, value: item.Id}
				this.FinancedAllOptions.push(elFinanced)
			})

			const resultReceivingSupportCompanies = await http.get(process.env.VUE_APP_API_FOLDER + "/GetReceivingSupportCompanies");
			this.ReceivingSupportCompaniesAllOptions = resultReceivingSupportCompanies.status === 200 ? resultReceivingSupportCompanies.data : [];

			const resultFinancedCompanieRecords = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinancedCompanieRecords");
			this.FinancedCompanieRecords = resultFinancedCompanieRecords.status === 200 ? resultFinancedCompanieRecords.data : [];

			const resultReceivingAgreements = await http.get(process.env.VUE_APP_API_FOLDER + "/GetReceivingAgreements");
			this.ReceivingAgreementsAllOptions = resultReceivingAgreements.status === 200 ? resultReceivingAgreements.data : [];

			// console.log('All financed',this.FinancedAllOptions);

			// console.log('EditEnergySite ID:' + this.id);

			if(this.id !='00000000-0000-0000-0000-000000000000') {
				//this.tmpTitleStation = 'EDITING Energy site'
				
				//console.log('Imam ID, torej nalagam podatke, delam EDIT');
				//console.log(process.env.VUE_APP_API_FOLDER + "/GetEnergySite?id=" + this.id);
				var result=null;

				try {
					const resultTmp = await http.get(process.env.VUE_APP_API_FOLDER + "/GetEnergySite?id=" + this.id);	
					result = resultTmp;
				} catch (error) {
					// console.log('AXIOS ERROR response!');
					console.log(error.response);
				}	
				
				

				//console.log("prejel nazaj:");
				//console.log(result);

				if (result.status == 200) {
					this.energysite = result.data;
					this.energysite.Country = "Slovenija";

					this.energysite.thirdpartyowner = this.energysite.PoolOwnerType == null ? false : true;	

					// console.log('dodajam za sort');
					// moram workingHours dodati atribut dayinweekindex
					this.energysite.WorkingHours.forEach(element => {
						element.DayIndex = this.getDayInWeekIndex(element.DayInWeek)
					});
					// console.log('dodal sort');
					// console.log(this.energysite.WorkingHours);
					//console.log('Kaj imam sedaj v EnergySite:' + this.energysite.Id)
					//console.log(this.energysite)


					//console.log('Marker v polnilnici');
					//console.log(this.energysite);
					//if(this.energysite.lat != undefined && this.energysite.long != undefined) {
						//console.log('DELAM MARKER');
						//console.log(this.energysite.Lat);
						//console.log(this.energysite.Long);
						try {
							if(Number.isFinite(this.energysite.Lat) && Number.isFinite(this.energysite.Long))
							{
								try {

									var geometry = {"type": "Point","coordinates": [ this.energysite.Long, this.energysite.Lat ]};
									
									// console.log(this.mc);
									// console.log(geometry);

									this.mc.evt_mapLoad.subscribe(() => {

										// console.log('RIŠEM PIN');
										// console.log(geometry);

										this.mc.drawMarker(
											geometry, {
												minResolution: 1,
												projection: 'EPSG:4326',
												pan: true,
												animate: true,
												size: 0.25,
												icon: 'marker_red-128',
												cameraOptions: {
                                					zoom: 11
                            					},
												relCenterX: 0.5,
												relCenterY: 0.5
											}
										);                                                                      
									});
									


									/*
									this.mc.drawMarker(
									{"type": "Point","coordinates": [ this.energysite.Long, this.energysite.Lat ]}, {
										minResolution: 1,
										projection: 'EPSG:4326',
										pan: true,
										animate: true,
										icon: 'marker_red-128',
										autoZoom: true,
										relCenterX: 0.5,
										relCenterY: 0.5
									});
									*/
								} catch (error) {
									console.log('Prišlo je do errorja pri PIN-u : drawMarker');
									console.log(error);
								}
							}
								
						} catch (error) {
							console.log('Prišlo je do errorja pri PIN-u');
							console.log(error);
						}

					//}			
				}
			} else {
				
				//console.log('NIMAM ID, delam NEW!!!');
				this.energysite.Id = '00000000-0000-0000-0000-000000000000';
				//console.log('submitted: ' + this.submitted);
				//this.mc = new rmap2.MapContainer("rm2Map");
			}

			this.isLoading=false;


		});


    
  },
  methods: {
	spremembaTipLastnikaLokacije() {
		if(this.energysite.LocationType!='pravnaoseba') {
			this.energysite.OwnerRegisterId = '';
			this.energysite.OwnerTaxId = '';
		}
		//console.log('kliknil lastnika lokacije combo');
	},
	removeFuelData(tmpfueldata) {
		
		// console.log('removeFuelData', tmpfueldata, this.energysite.FuelSpecificData, tmpfueldata.organicGasType==null);
		//console.log(this.energysite.FuelSpecificData);
		// const arr = this.energysite.FuelSpecificData.filter(item => (tmpfueldata.id != '00000000-0000-0000-0000-000000000000' && item.Id != tmpfueldata.id) || (tmpfueldata.id == '00000000-0000-0000-0000-000000000000' && item.Fuel != tmpfueldata.Fuel && item.OrganicGasType != tmpfueldata.organicGasType))
		const arr = this.energysite.FuelSpecificData.filter(item => {
			// If the fuel is OrganicGas, also check the organicGasType.
			if (item.Fuel === tmpfueldata.fuel) {
				return item.OrganicGasType !== tmpfueldata.organicGasType;
			}
			// Otherwise, keep the item.
			return true;
		});

		this.energysite.FuelSpecificData = arr
		//console.log(this.energysite.FuelSpecificData);
	},
	openModalAddStation() {           
		this.tmpStationName=""
		this.tmpStationEvseid="" 
		this.tmpStationNotes=""
		this.displayModalAddStation = true
	},
	openModalAddWorkingHour() {   
		//console.log('delam addWorkingHour');
		//console.log(this.translated('workinghourpopuptitle'));
		this.errDan = false;
		this.errOd = false;
		this.errOdMin = false;
		this.errDo = false;
		this.errDoMin = false;

		this.tmpWorkingHourId = null
		this.workingHourPopupTitle = this.translated('workinghourpopuptitle') // this.tmpTitleAddWorkingHour        
		this.tmpDayInWeek = null
		this.displayModalAddWorkingHour = true
	},
	openModalEditWorkingHour(workingHourObj) {  
		//console.log('odpru popup za edit')
		//console.log(workingHourObj)
		this.errDan = false;
		this.errOd = false;
		this.errOdMin = false;
		this.errDo = false;
		this.errDoMin = false;

		this.tmpWorkingHourId = workingHourObj.Id 
		this.tmpDayInWeek = workingHourObj.DayInWeek
		this.tmpOpenHour = this.formatAsString(workingHourObj.OpenFromHour)
		this.tmpOpenMinute = this.formatAsString(workingHourObj.OpenFromMinute)
		this.tmpCloseHour = this.formatAsString(workingHourObj.OpenTillHour)
		this.tmpCloseMinute = this.formatAsString(workingHourObj.OpenTillMinute)

		this.workingHourPopupTitle = this.translated('workinghourpopuptitedit') //this.tmpTitleEditWorkingHour        
		this.displayModalAddWorkingHour = true
	},		
	addWorkingHour() {
		console.log(this.energysite.WorkingHours);
		if(!this.energysite.WorkingHours) {
			//console.log('nimam arraya, dodam array!!!')
			this.energysite.WorkingHours = new Array()
		}
		
		const newId = this.createGuid()
		const tmpFromInt = this.tmpOpenHour * 60 + (this.tmpOpenMinute * 1)
		const tmpTillInt = this.tmpCloseHour * 60 + (this.tmpCloseMinute * 1)
/*
		console.log(tmpFromInt)
		console.log(tmpTillInt)
		console.log('Guid:' + newId)
		console.log('dodam working hour')
		console.log('Stari ID:' + this.tmpWorkingHourId);
		*/
		// sedaj preverim ali je v tmpId ze vrednost ali je null. Ce je null potem je novo drugace je edit
		if(!this.tmpWorkingHourId) {
			// imam id, torej delam edit!
			this.energysite.WorkingHours.push({
				Id: newId, 
				DayInWeek: this.tmpDayInWeek, 
				OpenFromHour: parseInt(this.tmpOpenHour),
				OpenFromMinute: parseInt(this.tmpOpenMinute),
				OpenTillHour: parseInt(this.tmpCloseHour),
				OpenTillMinute: parseInt(this.tmpCloseMinute),
				OpenFromInt: tmpFromInt,
				OpenTillInt: tmpTillInt,
				DayIndex: this.getDayInWeekIndex(this.tmpDayInWeek)
			})			
		} else {
			/*
			console.log('vsi workigh hours')
			console.log(this.energysite.WorkingHours)
			console.log('editiram, poiščem starega')
			*/
			const objIndex = this.energysite.WorkingHours.findIndex(obj => obj.Id === this.tmpWorkingHourId)

			//console.log('id starega:' + objIndex)
			this.energysite.WorkingHours[objIndex].DayInWeek = this.tmpDayInWeek
			this.energysite.WorkingHours[objIndex].OpenFromHour = parseInt(this.tmpOpenHour)
			this.energysite.WorkingHours[objIndex].OpenFromMinute = parseInt(this.tmpOpenMinute)
			this.energysite.WorkingHours[objIndex].OpenTillHour = parseInt(this.tmpCloseHour)
			this.energysite.WorkingHours[objIndex].OpenTillMinute = parseInt(this.tmpCloseMinute)
			this.energysite.WorkingHours[objIndex].OpenFromInt = tmpFromInt
			this.energysite.WorkingHours[objIndex].OpenTillInt = tmpTillInt
		}
		/*
		console.log(this.energysite)
		console.log(this.energysite.WorkingHours)
		*/
	},
	closeAndAddModalAddStation() {
		this.energysite.ChargeStations.push({Name: this.tmpStationName, CreatedDate: Date.now(), EvseId: this.tmpStationEvseid, Notes: this.tmpStationNotes, AuthenticationAndIdentificationMethod: this.tmpAuth})
		this.displayModalAddStation = false
		//console.log(this.energysite)
	}, 
	closeModalAddStation() {
		this.displayModalAddStation = false
		//console.log(this.energysite)
	}, 	 
	closeAndAddModalAddWorkingHour() {
		console.log(this.tmpDayInWeek)

		this.errDan = this.tmpDayInWeek == null;
		this.errOd = this.tmpOpenHour == null;
		this.errOdMin = this.tmpOpenMinute == null;
		this.errDo = this.tmpCloseHour == null;
		this.errDoMin = this.tmpCloseMinute == null;
			
			
		if(this.errDan || this.errOd || this.errDoMin || this.errDo || this.errDoMin)
			return;

		this.displayModalAddWorkingHour = false
		this.addWorkingHour()
	},
	closeModalAddWorkingHour() {
		this.displayModalAddWorkingHour = false
	},
	editWorkingHour(workingHourObj) {
		//console.log(workingHourObj)
		//console.log({...workingHourObj})
	},
	deleteWorkingHour(workingHourObj) {
		const wh = {...workingHourObj}
		const arr = this.energysite.WorkingHours.filter(function(item) {
				return item.Id !== wh.Id
		})
		//console.log('tole je filtrirano');
		//console.log(arr);
		this.energysite.WorkingHours = arr
	},
	removeElementEvent(parametri) {
		//console.log('kliknil remove');
		//console.log(parametri)
		const arr = this.energysite.ChargeStations.filter(function(item) {
			if(parametri.id)
				return item.Id !== parametri.id
			else
				return item.CreatedDate !== parametri.CreatedDate
		})

		this.energysite.ChargeStations = arr
	},
	createGuid() {  
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {  
			var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8) 
			return v.toString(16)
		});  
	},
	async handleSubmit(isFormValid) {
		//console.log('Prisel v SUBMIT');
		//console.log(this.v$);
		//const isInvalid = this.v$.MSPCode.$invalid;
		//console.log('isFormValid: ' + isFormValid);
		this.submitted = true;

		if (!isFormValid) {
			return;
		}

		this.isLoading = true;

/*
		console.log('klicem submit!!! NOVO')
		console.log(this.energysite)
		*/
		
		const http = createHttp(true); 
		try {
			// console.log(JSON.stringify(this.energysite));

			
			if(this.energysite.thirdpartyowner == false) {
				this.energysite.PoolOwnerName = '';
				this.energysite.PoolOwnerRegisterId = '';
				this.energysite.PoolOwnerTaxId = '';
				this.energysite.PoolOwnerType = null;
			}


			const response = await http.post(process.env.VUE_APP_API_FOLDER + "/InsertUpdateEnergySite?languageCode=SI", this.energysite);
			console.log('response na insert')
			console.log(response)

			if(response.status==200) {
				this.serverSubmitError='';
				this.isLoading = false;
				//console.log('VSE JE OK!!!');
				this.$toast.add({severity:'success', summary:'Confirmed', detail:'Energy site saved!', life: 3000});
				console.log('redirecting... to locations...');
				setTimeout(() => this.$router.push('/locations'), 1500);								
			} else {
				console.log('ERROR!!!')
				console.log(response);
				this.$toast.add({severity:'error', summary:'Napaka', detail:'Napaka pri shranjevanju. Podatki niso shranjeni!', life: 5000});
				this.isLoading = false;
			}

			this.isLoading = false;
			//console.log(response)
		} catch (error) {
			//console.log('ERROR TRY CATCHE!');
			//console.log(error);
			console.log('ERROR:');
			console.log(error.response);

			this.$toast.add({severity:'error', summary:'Napaka', detail:'Napaka pri shranjevanju. Podatki niso shranjeni!', life: 5000});
			this.isLoading = false;
			//this.serverSubmitError = error.response.data.detail;
			/*
			//console.log('Logiram 1');
			if(error.response.status==500) {
				//console.log('logiram 2');
				this.serverSubmitError = error.response.data.detail;
				//this.isLoading = false;
			}
			*/
		}
		
		
	},
	formatTime(hour,minute) {
		const h = ('0' + hour).slice(-2)
		const m = ('0' + minute).slice(-2)
		return h + 'h ' + m + 'min'
	},
	formatAsString(value) {
		return ('0' + value).slice(-2)
	},
	getDayInWeekIndex(dayName) {

		switch (dayName.toLowerCase()) {
			case "monday":
				return 0;
			case "tuesday":
				return 1;
			case "wednesday":
				return 2;
			case "thursday":
				return 3;
			case "friday":
				return 4;
			case "saturday":
				return 5;
			case "sunday":
				return 6	
			default:
				return 0;
		}
	},
	async removeEnergySite() {
		console.log('odstranil bom polnilnico id: ' + this.id);
		this.$confirm.require({
			message: this.translated('deleteconfqu'),
			header: this.translated('deleteconftitle'),
			acceptLabel: this.translated('yesbutton'),
			rejectLabel: this.translated('nobutton'),
			icon: 'pi pi-info-circle',
			acceptClass: 'p-button-danger',
			accept: async () => {
				this.isLoading = true;
				try {
					const http = createHttp(true);
					const resultTmp = await http.delete(process.env.VUE_APP_API_FOLDER + "/DeleteEnergySite?id=" + this.id);	
				} catch (error) {
					console.log('AXIOS ERROR response!');
					console.log(error.response);
				}	
				this.isLoading = false;
				// sedaj naredim redirekt na vse polnilnice
				this.$router.push('/locations')
			}
		});		
	}

  },
};
</script>

<style scoped lang="scss">
.ownersection input:disabled {
    background: #9e9e9e;
}

.field.grid.ownersection {
    margin-top: 30px;
} 

.latlongplaceholder {
	margin-top: 30px;
}

.stationnotes {
	height:240px;
}

.fueldatasection {
    margin-top: 40px;
}

button.deletebutton, button.editbutton {
    position: relative;
    float: right;
}

button.removeenergysite {
	width: auto;
    position: relative;
    float: right;	
}

button.lockremovesite {
    position: relative;
    float: right;	
	margin-right: 10px;	
}

input.editenabledExternalID {
	width: calc( 100% - 50px );
}

button.btneditenabledExternalId {
	margin-left: 5px;
}

.rightColData {
	border-left: 1px solid lightgrey;
}

.col-12.stationsHeader {
    width: calc( 100% - 50px);
    position: relative;
    float: left;
}

.stationHeaderAdd {
    position: relative;
    float: right;
    margin: 5px;
}
textarea {
    width: 100%;
	resize: none;
}

.confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
}

.saveCard button.p-button.p-component {
    width: 150px;
}

.col-12.saveCardRow {
    text-align: center;
}

.card.fluid.saveCard {
    height: 150px;
}

.col-12.placeholderformap {
    height: 400px;
    margin-top: 20px;
}

::saga-blue(.dark-panel.p-panel) {
    .p-panel-titlebar {
        background: #212121;
    }

}

.servererrormessage {
    text-align: center;
    color: red;
    margin-bottom: 30px;
}
.cardheader { height: 55px; }

.vsepolnilnice {float: left; margin-right: 10px; }
.davcnamaticnapoolowner {margin-top: 25px; margin-bottom: 30px;}
.clsESHeaderGroup {
    display: flex;
    justify-content: space-between;
}

.clsESHeader {
    display: flex;
    align-items: center;
}


.adminheadernamegroup {
    display: flex;
    flex-direction: column;
}

h6.stationsHeaderAdmin {
    margin: 0;
}
</style>
